window.shouldShowAmbassadorBanner = function () {
    return readCookie('dc_mbsy_cookie') !== null &&
        window.isLoggedInOrRemembered() &&
        window.isUserTypeTeacher() &&
        userObj &&
        typeof userObj.hasSubmittedAProject !== 'undefined' &&
        !userObj.hasSubmittedAProject;
};
